// --------------------------------------------------------------
// Created On: 2026-03-20
// Author: Dimitra Weinstein
//
// Last Modified: 2026-04-08
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React from "react";

// Explains what a subsidiary company is.
export default function HelpSubsidiary(): Component {
  return (
    <div>
      <p className="px-3 my-2">
        <b>What is a Subsidiary Company?</b>
        <br />
        Subsidiary companies are separate entities managed by a parent company. Users within the parent company who have
        the appropriate permissions can step into that subsidiary to perform tasks, access, and configure resources
        specific to that subsidiary company.
        <br />
        <br />
        Creating subsidiary companies allows a parent company to manage multiple distinct entities within a single
        parent company account. Each subsidiary company can have its own unique set of users, assets, alerts, and other
        resources that are separate from the parent company and any other subsidiaries. This structure is particularly
        useful for organizations that operate in multiple regions or have different departments that require separate
        management while still being under the umbrella of a single parent company.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Parent-Subsidiary Hierarchical Structure</b>
        <br />A subsidiary company can have its own subsidiaries, allowing for a hierarchical structure of companies.
        This hierarchical chain cannot not exceed 5 levels. This includes the parent company.
        <br />
        For example, a parent company (level 1) can have a subsidiary company (level 2), which in turn has its own
        subsidiary company (level 3), and so on, up to 5 levels deep.
      </p>

      <p className="px-3 mt-3 mb-2">
        <b>Releasing a Subsidiary Company</b>
        <br />
        If a parent company no longer needs to manage a subsidiary company, then the parent company can release the
        subsidiary company. Once a subsidiary company is released, it becomes its own independent company that is no
        longer associated with the parent company. The subsidiary company can then be managed as its own separate
        entity, and the parent company will no longer have access to the subsidiary company&apos;s resources or data.
      </p>
    </div>
  );
}
